import { useContext } from 'react';
import { useSelector } from 'react-redux';
import MetricsInspectionContext from '../../../state/context';
import { StyledCell } from '../Table.style';
import AuthorsCell from '../common/cells/AutorsCell';
import NameCell from '../common/cells/NameCell';
import { BRANCHES_MODEL, BRANCHES_TABLE_MODEL } from './branches.model';
import { contributorsByIdSelector } from 'state/selectors/contributors';
import StateCell from '../common/cells/StateCell';
import { get } from 'lodash';
import BranchMetricValueCell from '../common/cells/BranchMetricValueCell';
import { ACTIVITY_TYPES } from '../../../state/state.utils';
import { mapActivityTypeToEntityKey } from '../../../Charts/ScatterChart/useFetchData/entities.utils';
import AccountedCycleTimeCell from '../common/cells/AccountedCycleTimeCell';
import { repositoriesByIdSelector } from 'state/selectors/repositories';

const useRows = ({ data } = {}) => {
  const {
    state: { hoveredPoint, widget }
  } = useContext(MetricsInspectionContext);

  const highlightId =
    hoveredPoint?.extraData?.[
      mapActivityTypeToEntityKey[ACTIVITY_TYPES.BRANCHES]
    ];

  const contributorsById = useSelector(contributorsByIdSelector);
  const repositoriesById = useSelector(repositoriesByIdSelector);

  const branches = data?.items || [];

  const rows = branches.map(branch => {
    const id = branch?.id;

    const repoId = branch?.[BRANCHES_MODEL.REPO_ID];
    const repoName = repositoriesById[repoId]?.name || '';

    const contributorIds = branch?.[BRANCHES_MODEL.CONTRIBUTOR_IDS] || [];
    const contributors = contributorIds
      .map(id => contributorsById[id])
      .filter(Boolean);

    const state = branch?.[BRANCHES_MODEL.STATE];
    const name = branch?.[BRANCHES_MODEL.NAME]?.replace(/origin\//g, '') || '';
    const prIssuerId = get(branch, BRANCHES_MODEL.PR.ISSUER_ID);
    const prIssuer = get(contributorsById, prIssuerId, {});

    return {
      styles: { highlight: id === highlightId },
      [BRANCHES_TABLE_MODEL.NAME_CELL]: (
        <NameCell
          name={name}
          url={get(branch, BRANCHES_MODEL.PR.URL)}
          element='Branches'
          widgetName={widget?.name}
        />
      ),
      [BRANCHES_TABLE_MODEL.REPOS_CELL]: <StyledCell>{repoName}</StyledCell>,
      [BRANCHES_TABLE_MODEL.AUTHORS_CELL]: (
        <AuthorsCell contributors={contributors} />
      ),
      [BRANCHES_TABLE_MODEL.PR_ISSUER_CELL]: (
        <AuthorsCell contributors={[prIssuer]} />
      ),
      [BRANCHES_TABLE_MODEL.STATE_CELL]: <StateCell state={state} />,
      [BRANCHES_TABLE_MODEL.METRIC_VALUE_CELL]: (
        <BranchMetricValueCell branch={branch} />
      ),
      [BRANCHES_TABLE_MODEL.ACCOUNTED_CYCLE_TIME_VALUE_CELL]: (
        <AccountedCycleTimeCell branch={branch} />
      )
    };
  });

  return rows;
};

export default useRows;
